<template>
  <v-container>
    <div class="famiglia">
      <h1>{{ famiglia }}</h1>
    </div>
    <div>
      <!-- Messaggio in italiano -->
      <p
        v-if="
          (visibilityData === 'ZEK' || visibilityData === 'ZEB') && !isEnglish
        "
        class="alert-box-custom"
      >
        L'articolo è fuori produzione, disponibile fino ad esaurimento scorte o
        su richiesta.
      </p>

      <!-- Messaggio in inglese -->
      <p
        v-if="
          (visibilityData === 'ZEK' || visibilityData === 'ZEB') && isEnglish
        "
        class="alert-box-custom"
      >
        This item is available until stocks run out or upon request.
      </p>
    </div>
  </v-container>
</template>
<script>
import axios from "axios";

export default {
  name: "familyTitle",

  // this.$store.state.product_store.CODICE_UNIVOCO
  data() {
    return {
      famiglia: "",
      visibilityData: null,
      isEnglish: false, // Flag per determinare se la lingua è inglese
      error: null,
    };
  },
  computed: {
    // Create a computed property to bind to the store's state
    productCode() {
      return this.$store.state.product_store.CODICE_UNIVOCO;
    },
  },
  watch: {
    productCode: {
      immediate: true,
      handler: "fetchVisibility",
    },
  },
  methods: {
    fetchVisibility() {
      this.error = null;
      this.visibilityData = null;

      axios
        .get(
          `https://vistosi.it/api/get-product-visibility.php?product_code=${this.productCode}`
        )
        .then((response) => {
          this.visibilityData = response.data;
        })
        .catch((error) => {
          this.error = `Error fetching : ${error.message}`;
        })
        .finally(() => {
          // code
        });
    },
    checkLanguage() {
      // Ottieni i parametri della query string
      const queryParams = new URLSearchParams(window.location.search);
      // Controlla se lang=EN è presente
      if (queryParams.get("lang") === "en") {
        this.isEnglish = true;
      }
    },
  },

  async mounted() {
    this.famiglia = "";
    if (typeof window.descrizione.descrizione.fita == "string") {
      this.famiglia = window.descrizione.descrizione.fita.toLowerCase();
    }
    // Controlla il linguaggio
    this.checkLanguage();
  },
};
</script>
<style scoped>
.famiglia h1 {
  text-transform: capitalize;
}
.alert-box-custom {
  display: inline-block !important; /* Adatta la larghezza al contenuto */
  border: 1px solid #000000 !important; /* Bordo nero */
  background-color: #f3f3f3 !important; /* Colore di sfondo tenue */
  padding: 12px !important; /* Spaziatura interna */
  border-radius: 2px !important; /* Angoli arrotondati */
  font-size: 16px !important; /* Dimensione del carattere */
  color: #000000 !important; /* Colore del testo */
  margin: 20px 0 !important; /* Margine sopra e sotto */
}
</style>
